import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('users_companyname'),
};

export const messagesActions = {
    usersInvitedNotification: defineMessage('count_plural_one_user_invited_other_users_invited'),
    usersAddedNotification: defineMessage('count_plural_one_user_added_other_users_added'),
    theUserIsDelegateHimselfNotification: defineMessage('name_cannot_be_set_a_su_s_a_substitute_themself'),
};

export const messagesSagas = {
    changesSavedNotificationMessage: defineMessage('changes_saved'),
    delegateSetNotificationMessage: defineMessage('substitute_set_up'),
    delegateClearNotificationMessage: defineMessage('substitute_removed'),
    roleChangedNotificationMessage: defineMessage('user_role_has_been_changed'),
};
